import * as React from 'react';
const Sparkles: React.FC<{ stroke: string }> = ({ stroke }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none">
    <path
      stroke={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M4.167 2.5v3.333V2.5ZM2.5 4.167h3.333H2.5Zm2.5 10V17.5v-3.333Zm-1.667 1.666h3.334-3.334Zm7.5-13.333 1.905 5.714L17.5 10l-4.762 1.786-1.905 5.714-1.905-5.714L4.167 10l4.761-1.786L10.833 2.5Z"
    />
  </svg>
);
export default Sparkles;
